import { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import classes from './EventCard.module.scss';
import noPhoto from '../../../images/noPhoto.png';
import { GeneralContext } from '../../../context/generalContext';
import { lambicClubLinkAPI } from '../../../services/GeneralService';

export default function ArtiEventCardcleCard({ item }) {
  const { activeLanguage } = useContext(GeneralContext);
  const { data: clubLink } = lambicClubLinkAPI.useFetchAllLabicClubLinkQuery();

  let tempDiv = null;
  // ignore text inside style tag
  const reg = /(?=<style>)(.*)(?:style>)/gi;
  if (item.content.length !== 0) {
    tempDiv = document.createElement('div');
    activeLanguage === 1
      ? (tempDiv.innerHTML = item.content[0].text.replace('<strong>', '').replace(reg, ''))
      : (tempDiv.innerHTML =
          item.content[0].text_en.replace('<strong>', '').replace(reg, '') ||
          item.content[0].text.replace('<strong>', '').replace(reg, ''));
  }

  let myText = '';

  if (tempDiv && tempDiv.hasChildNodes()) {
    myText = `${tempDiv.children[0].textContent} ${tempDiv.children[1] ? tempDiv.children[1].textContent : ''}`;
  }

  const [classNamesTitle, setClassNamesTitle] = useState(classes.cardTitle);
  const [classNamesText, setClassNamesText] = useState(classes.cardText);

  useEffect(() => {
    if (myText) {
      if (item.title.length <= 29) {
        setClassNamesTitle(`${classes.cardTitle} ${classes.__short}`);
        setClassNamesText(`${classes.cardText} ${classes.__long}`);
      }
    }
  }, [myText]);
  return (
    // если "Ламбик Клуб" - на отдельную страницу, остальное - на стандартную
    <Link
      to={
        item.title === 'Вступайте в клуб привелегий Lambic Club!'
          ? activeLanguage === 1
            ? `${clubLink || '/events/lambicclub'}`
            : `/en${clubLink || '/events/lambicclub'}`
          : activeLanguage === 1
            ? `/events/${item.name}`
            : `/en/events/${item.name}`
      }
      className={classes.cardLink}
    >
      <div className={classes.card}>
        <LazyLoadImage className={classes.cardImg} src={item.img ? item.img : noPhoto} alt='event illustration' />
        <div className={classes.cardDescription}>
          <div className={classNamesTitle}>{activeLanguage === 1 ? item.title : item.title_en || item.title}</div>
          <div className={classes.cardTextDate}>
            <p className={classNamesText} dangerouslySetInnerHTML={{ __html: myText }} />
            <p className={classes.cardDate}>
              {activeLanguage === 1
                ? new Date(item.date)
                    .toLocaleString('ru', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                    .slice(0, -3)
                : new Date(item.date).toLocaleString('en', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}
